import React, { useMemo } from "react";
import BoardCardShell from "../BoardCardShell";
import BoardChartRegion from "../BoardChartRegion";
import BoardCardState from "../BoardCardState";
import FunnelVisualization from "features/analytics/studio/components/charts/FunnelVisualization";
import FunnelDataTable from "features/analytics/studio/components/charts/FunnelDataTable";
import { DEFAULT_FUNNEL_TABLE_COLUMNS } from "features/analytics/studio/constants/funnelTableColumns";

const BADGE = { label: "Funnel", bg: "var(--feedback-warning-bg)", color: "var(--feedback-warning)" };

export default function FunnelBoardCard({ card, result, onEdit, onDelete, readOnly }) {
  const measuring = card?.queryDsl?.definition?.measuring || "conversion_rate";
  const steps = result?.data?.steps || [];
  const breakdowns = result?.data?.breakdowns || [];
  const overallConversionRate =
    steps.length > 1 ? steps[steps.length - 1]?.conversion : steps.length === 1 ? 100 : null;

  const stepsWithMeasuring = useMemo(
    () => steps.map((s) => ({ ...s, measuring: s.measuring || measuring })),
    [steps, measuring]
  );

  const funnelTableColumnsMerged = {
    ...DEFAULT_FUNNEL_TABLE_COLUMNS,
    ...(card?.visualization?.config?.funnelTableColumns || {}),
  };

  const actions = readOnly ? [] : [
    ...(onEdit ? [{ label: "Edit", icon: "edit_pencil", onClick: onEdit }] : []),
    ...(onDelete ? [{ label: "Delete", icon: "delete", onClick: onDelete, danger: true }] : []),
  ];

  const state = !result ? "loading" : result.error ? "error" : steps.length === 0 ? "empty" : null;
  const errorMsg = typeof result?.error === "string" ? result.error : "Could not load funnel";

  // Footer: data table (only when there's data)
  const footer = !state && steps.length > 0 ? (
    <FunnelDataTable
      steps={stepsWithMeasuring}
      measuring={measuring}
      breakdowns={breakdowns}
      tableColumns={funnelTableColumnsMerged}
      compact
    />
  ) : null;

  return (
    <BoardCardShell
      title={card?.title || "Funnel"}
      badge={BADGE}
      actions={actions}
      readOnly={readOnly}
      footer={footer}
    >
      {state ? (
        <BoardCardState state={state} message={state === "error" ? errorMsg : "No funnel data"} />
      ) : (
        <BoardChartRegion>
          {({ height }) => (
            <FunnelVisualization
              steps={stepsWithMeasuring}
              measuring={measuring}
              overallConversionRate={overallConversionRate}
              breakdowns={breakdowns}
              chartHeight={Math.max(80, height)}
              boardCompact
            />
          )}
        </BoardChartRegion>
      )}
    </BoardCardShell>
  );
}
